// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__S7PP9","containerItemsCenter":"Skeleton_containerItemsCenter__2RsQr"};